import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=b1f9dedc&scoped=true&lang=html&"
import script from "./Record.vue?vue&type=script&lang=ts&"
export * from "./Record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f9dedc",
  null
  
)

export default component.exports